import { StyleSheet } from 'aphrodite'

import selector from './selector'

export default {
  selector: StyleSheet.create(selector)
}



// WEBPACK FOOTER //
// ./src/components/Community/User/Main/partials/Selector/style/index.js